import { render, staticRenderFns } from "./payments-history.vue?vue&type=template&id=c038f420&"
import script from "./payments-history.vue?vue&type=script&lang=js&"
export * from "./payments-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports